import React from 'react';
import { connect } from 'react-redux';
import styles from './styles/user-message.module.css';
import { EditOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { rewindToBlock } from '@/store/slices/middleware/chatbotFlowThunk';
import store from '@/store/store';
import InputTypes from '@/constants/InputTypes';
import { formatCurrency } from '@/helpers/SalaryInputHelper';
import { isSkipped } from '@/helpers/Flow';
import { DataBlockDataTypes } from '@/constants/DataTypes';
import { useTranslation } from 'react-i18next';

const UserMessage = props => {
  const { t } = useTranslation();

  const getText = block => {
    if (isSkipped(block)) return block.skip?.text;
    if (
      block?.dataType == "CANDIDATE_VINCERE_GDPR_CONSENT_TO_KEEP" ||
      block?.dataType == "CANDIDATE_VINCERE_GDPR_RIGHT_TO_REPRESENT"
    ) {
      return block?.answerForDisplay?.title
    }
    switch (block.inputType) {
      case InputTypes.GENDER:
        const genderOption =
          block?.answer &&
          block?.answer.find(option => option.value === block?.answer);
        return genderOption ? genderOption.description : t('notSpecified');
      case InputTypes.DATE_PICKER:
        return block?.answerForDisplay?.join(' | ');
      case InputTypes.MULTIPLE_SELECT_OPTIONS:
        return block?.answer?.map(opt => opt?.title)?.join(', ');
      case InputTypes.GEOLOCATION:
        if (block?.answer?.lat) {
          return t('locationCoordinates', {
            lat: block?.answer?.latitude,
            lng: block?.answer?.latitude,
          });
        }
        return t('locationNotAvailable');
      case InputTypes.SALARY_PICKER:
        const { currency = 'GBP', period } = block?.options;
        if (block?.answer) {
          const { min, max } = block?.answer;
          const translatedPeriod = t(`periods.${period}`);
          if (block?.options?.inputType === 'number')
            return `${formatCurrency(min, currency)}${
              translatedPeriod ? ` ${translatedPeriod}` : ''
            }`;
          else
            return t('salaryRange', {
              min: formatCurrency(min, currency),
              max: formatCurrency(max, currency),
              period: translatedPeriod ? ` ${translatedPeriod}` : '',
            });
        } else return `-`;
      case InputTypes.FILE_UPLOAD:
        return block?.answer?.name;
      case InputTypes.TAG_LIST:
        return block?.answer?.join(', ');
      case InputTypes.USER_TYPE:
        return block?.answer?.title;
      case InputTypes.JOB_TYPE:
        return block?.answer?.title;
      case InputTypes.DATA_SEARCH:
        if (block?.answer?.length > 0) {
          if (block.dataType === DataBlockDataTypes.CANDIDATES)
            return t('interestedInCandidates', { count: block?.answer?.length });
          if (block.dataType === DataBlockDataTypes.JOBS)
            return t('interestedInJobs', {
              count: block?.answer?.length,
              plural: block?.answer?.length > 1 ? 's' : '',
            });
          else return t('selectedItems', { count: block?.answer?.length });
        }
        break;
      default:
        return block?.answer;
    }
  };

  return (
    <div className={styles.full_wrapper}>
      <div className={styles.wrapper}>
        {!props.isFinished &&
          (props.block.inputType !== InputTypes.DATA_SEARCH ||
            isSkipped(props.block) ||
            (props.block.inputType === InputTypes.DATA_SEARCH &&
              props.block?.answer?.length !== 0)) && (
            <EditOutlined
              onClick={() =>
                store.dispatch(rewindToBlock(props.block.index))
              }
            />
          )}
        <p
          style={{
            backgroundColor:
              props.settings?.user?.messageBackgroundColor || '#53d769 ',
            color: props.settings?.user?.messageTextColor || '#f7f7f7 ',
          }}
        >
          {getText(props?.block)}
        </p>
      </div>
    </div>
  );
};

UserMessage.propTypes = {
  block: PropTypes.object,
  settings: PropTypes.object,
};

const mapStateToProps = state => ({
  isFinished: state.chatbotFlow.isFinished,
  settings: state.chatbotDetails.settings,
});

export default connect(mapStateToProps)(UserMessage);
